module.exports = __webpack_public_path__ + "50a2bdd39b4c27ab3ac20d46755dfa8f.svg";